import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { getCommercials, deleteCommercial } from "../../../services";
import {LoginAsCommer} from "../../../services/auth.service"
import { Link } from "react-router-dom";
import Add from "../../../icons/add.svg";
import Lupa from "../../../icons/lupa.svg";
import Delete from "../../../icons/delete.svg";
import { Box, Tooltip } from "@mui/material";
import { DataTable } from "../../../components";
import FiltrosPersonal from "../../../components/filtros/filtrosPersonal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { UsuarioContext } from "../../../providers/userContext";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from "../../../functions/parametrosURL/funcionesParamsURL";
import { Login } from '@mui/icons-material';

const Comerciales = () => {
  const { t } = useTranslation('common');

  const urlPadre = window.location.pathname;
  const navigate = useNavigate();

  const user = useContext(UsuarioContext)
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);

  const filtrarDatos = (filtros) => {
    setBusqueda({ ...filtros });
    setBusquedaActiva(true);
  };

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const fetchData = async ({ offset, limit, filtros = busqueda, order,orderBy,} = {}) => {


    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros,  order,orderBy);
    const payload = {
      filtros,
      params: { page: offset, limit,  order,orderBy, },
    };
    try {
      setLoading(true);
      const response = await getCommercials(payload);
      const { meta, data } = response;
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const formatData = (data) => {
    return data.map((row, i) => ({
      id: i+1,
      nombre: row.nombre+" "+row.apellidos,
      correo:row.user[0].email,
      nif: row.nif,
      aaff: row.nif,
    }));
  };

  const comercialesRows = [

    {
      id: "nombre",
      numeric: false,
      disablePadding: false,
      label: t('commercials.columns.commercial'),
    },
    {
      id: "correo",
      numeric: false,
      disablePadding: false,
      label: t('commercials.columns.email'),
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('commercials.columns.nif'),
    },
    {
      id: "aaff",
      numeric: false,
      disablePadding: false,
      label: t('commercials.columns.propertyManagers'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <Link to={"/comerciales/" + row.nif + "/aaff"}>
          <img
            src={Lupa}
            alt={t('commercials.columns.propertyManagers')}
            className="tableIcon"
            ></img>
        </Link>
      )
    },
    user.rol === 'ADMIN' ?
    {
      id: "eliminar",
      numeric: false,
      disablePadding: false,
      label: t('commercials.columns.delete'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <img
          src={Delete}
          alt={t('actions.delete')}
          className="tableIcon"
          onClick={() => eliminarComercial(row)}
        ></img>
      )
    }
    :
    {

      noObjeto:true

    },
    user.rol === 'ADMIN' ?
    {
      id: "login",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Tooltip title={t('messages.loginAs', { name: row.nombre })} >
          <div className="bigBtn p-2" onClick={() => {LoginAsCommer(row.nif)}}>
            <Login fontSize="small" />
          </div>
        </Tooltip>
      )
    }
    :
    {

      noObjeto:true

    },
  ]

  const eliminarComercial = (com) => {
    let nombre = com.nombre + " " + com.apellidos;
    Swal.fire({
      title: t('commercials.messages.confirmDelete'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: t('actions.cancel'),
      confirmButtonText: t('messages.yesDelete'),
    })
      .then((result) => {
        if (result.isConfirmed) {
          deleteCommercial(com.nif)
            .then((res) => {
              if (res.message === "COMMERCIAL_DELETED") {
                toast.success(t('commercials.messages.deleted'));
                setRecargar(!recargar);
                window.history.back();
              } else {
                toast.error(t('commercials.messages.deleteError'));
              }
            })
            .catch((e) => {
              toast.error(t('commercials.messages.deleteError'));
              console.log(e);
            });
        }
      })
      .catch((e) => {
        toast.error(t('messages.error'));
        console.log(e);
      });
  };

  
  return (
    <>
      <BreadCrumb rutas={[{path:'/aaff', label: t('commercials.title')}]} style={{ margin: '0 10px'}} />
      <div className="listPage">
        <div className="gridCard">
            <div className="gridHead">
                {t('commercials.title').toUpperCase()}
            </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <div className="contentBar">
          {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol === "VENT") &&
            <>
              <div></div>
              <div style={{display: "flex"}}>
              <Link to="/comerciales/nuevo">
                <div className="contentButton">
                  <img src={Add} alt={t('commercials.new')} /><span>{t('commercials.new')}</span>
                </div>
              </Link>
              <Link to="/comerciales/nuevo-combo" style={{marginLeft: 10}}>
                <div className="contentButton">
                  <img src={Add} alt={t('commercials.newCombo')} /><span>{t('commercials.newCombo')}</span>
                </div>
              </Link>
              </div>
            </>
          }
        </div>
        <FiltrosPersonal
          onFilter={filtrarDatos}
          clearFilter={clearFilters}
          filtrosIniciales={busqueda}
        />
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comercialesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('commercials.messages.noCommercials')}
              />
            </Box>
          </Box>
        </div>
        {/* <div className="tableWrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th style={{ textAlign: "center" }}>Comercial</th>
                <th style={{ textAlign: "center" }}>NIF</th>
                <th style={{ textAlign: "center" }}>Administradores Fincas</th>
                {user.rol === "ADMIN" && 
                  <th style={{ textAlign: "center" }}>Eliminar</th>
                }
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    <CircularProgress style={{ color: "#92004D" }} />{" "}
                  </td>
                </tr>
              ) : (
                <></>
              )}
              {comerciales.map((e, i) => {
                return (
                  <tr key={i}>
                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                    <td style={{ textAlign: "center" }}>
                      {e.nombre + " " + e.apellidos}
                    </td>
                    <td style={{ textAlign: "center" }}>{e.nif}</td>
                    <td style={{ textAlign: "center" }}>
                      <Link to={"/comerciales/" + e.nif + "/aaff"}>
                        <img
                          src={Lupa}
                          alt="Administradores de Fincas"
                          className="tableIcon"
                        ></img>
                      </Link>
                    </td>
                    {user.rol === "ADMIN" && 
                      <td style={{ textAlign: "center" }}>
                        <img
                          src={Delete}
                          alt="ELIMINAR"
                          className="tableIcon"
                          onClick={() => eliminarComercial(e)}
                        ></img>
                      </td>
                    }
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div> */}
      </div>
    </>
  );
};

export default Comerciales;
